import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import Page from "../../components/Page";
import Sidebar from "../../components/Sidebar";
import SidebarDrawer from "../../components/SidebarDrawer";
import AddSkiller from "../Teammate/AddTeammate";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { url } from "../../url";

import CircularProgress from "@mui/material/CircularProgress";
import { useResetTeammateAtom } from "../../utils/useResetTeammateAtom";
import { TeammateDetailContent } from "../SingleTeammate/TeammateDetail";


const MySkillers = () => {
  const [teammateProfile, setTeammateProfile] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const resetTeammateAtoms = useResetTeammateAtom();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      const teammateProfileRes = await axios.get(url + "/user/myTeammate", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setTeammateProfile(teammateProfileRes.data.userTeammateProfile);
      setLoading(false);
    };
    fetchData();
  }, []);



  const goToCreateTeammate = () => {
    resetTeammateAtoms();
    navigate("/teammates/add");
  };



  return (
    <Page>
      <div className="mySkillers">
        <header className="mySkillers__header">
          <div className="mySkillers__header__sidebar">
            <SidebarDrawer />
          </div>
        </header>
        <div className="mySkillers__container">
          <div className="mySkillers__container__sidebar">
            <Sidebar />
          </div>
          <div className="mySkillers__container__savedSkillers">
            {!loading && (!teammateProfile || typeof teammateProfile !== 'object') ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center' }}>
                <h2 style={{ marginBottom: '2rem', fontSize: '1.8rem', color: '#374151', fontWeight: '400' }}>No skiller profile yet...</h2>
                <Button
                  onClick={() => goToCreateTeammate()}
                  variant="contained"
                  size="large"
                  style={{
                    width: '280px',
                    height: '80px',
                    fontSize: '1.2rem',
                    fontWeight: '500',
                    borderRadius: '6px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)',
                    transition: 'all 0.3s ease',
                    textTransform: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 12px 35px rgba(102, 126, 234, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.3)';
                  }}
                >
                  Create Skiller Profile
                </Button>
              </div>
            ) : !loading && teammateProfile && typeof teammateProfile === 'object' ? (
              <TeammateDetailContent dataFromMySkills={teammateProfile} isEmbedded={true} />
            ) : (
              <CircularProgress />
            )}
          </div>
        </div>
      </div>
    </Page>
  );
};

export default MySkillers;
